import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PriceListDTO } from '@lkp/parking-sdk';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-create-pricelist',
    templateUrl: './create-pricelist.component.html',
    styleUrls: ['./create-pricelist.component.scss'],
    standalone: false
})
export class CreatePricelistComponent implements OnInit {
  pricelistForm?: FormGroup;
  newPriceList?: PriceListDTO;

  readonly onDestroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<CreatePricelistComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    readonly formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    /* Create form */
    this.pricelistForm = this.formBuilder.group({
      name: new FormControl<string | undefined>(undefined, Validators.required),
      validFrom: new FormControl<Date | undefined>(
        new Date(),
        Validators.required
      ),
      validTo: new FormControl<Date | undefined>(undefined),
    });

    /* Listen to changes */
    this.pricelistForm.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        this.updatePricelist();
      });
  }

  updatePricelist(): void {
    this.newPriceList = {
      name: this.pricelistForm?.controls['name'].value,
      validFrom: this.pricelistForm?.controls['validFrom'].value,
      validTo: this.pricelistForm?.controls['validTo'].value,
    };
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onCreateClick() {
    this.dialogRef.close(this.newPriceList);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
